import SignupImg from "../../assets/images/webp/newStartHerePage/signupImage.webp";
import FitnessGoal from "../../assets/images/webp/newStartHerePage/fitnessGoalImg.webp";
import TellUs from "../../assets/images/webp/newStartHerePage/tellUsImg.webp";
import Equipment from "../../assets/images/webp/newStartHerePage/equipmentImg.webp";
import PointOne from "../../assets/images/webp/newStartHerePage/pointOne.webp";

import BulletText from "./bulletText";
import Workout from "./workout";

import CustomButton from "../../components/CustomButton";
import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const SignupSection = () => {
  const onSignUp = () => {
    window.open(CONSTANTS.baseUrl, "_blank");
  };

  return (
    <div className="signup-section">
      <div className="section-title">
        <div className="number">
          <img className="number-img" src={PointOne} alt="" />
        </div>
        <div className="title">Sign up</div>
      </div>
      <div className="signup-img-text">
        <div className="signup-left">
          <img className="signup-img" src={SignupImg} alt="sign up img" />
          <div className="signup-btn">
            <CustomButton type={CONSTANTS.ROUNDED_TYPE} handleClick={onSignUp}>
              Sign up now
            </CustomButton>
          </div>
        </div>
        <div className="signup-right">
          <BulletText text="Get started by giving us some basic information" />
        </div>
      </div>
      <div className="goals-section">
        <BulletText text="Tell us about your goals" />
        <div className="images">
          <div className="image-one">
            <img className="image" src={FitnessGoal} alt="fitness goal img" />
          </div>
          <div className="image-two">
            <img className="image" src={TellUs} alt="tell us img" />
          </div>
          <div className="image-three">
            <img className="image" src={Equipment} alt="equipment img" />
          </div>
        </div>
      </div>
      <div className="program-section">
        <div className="title">
          <BulletText text="Choose the program that works best for you!" />
        </div>
        <div className="workouts">
          {CONSTANTS.workoutDetails.map((workout, index) => {
            return (
              <Workout
                workoutImg={workout.workoutImage}
                monthlyPrice={workout.monthlyPrice}
                yearlyPrice={workout.yearlyPrice}
                workoutName={workout.workoutName}
                learnMoreTab={workout.tab}
                key={index}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default SignupSection;
